/**
 * Centralized, typed access to runtime environment configuration.
 *
 * Single source of truth for the backend API location: every HTTP call must
 * build its URL from `API_BASE_URL` rather than hard-coding a host or path.
 *
 * Set `VITE_API_BASE_URL` per environment: in development, point it directly
 * at the local Rails backend (e.g. `http://localhost:3000/v1`, CORS is open
 * there); in production, set the deployed API base (e.g.
 * `https://api.smerra.fr/v1`). When unset it falls back to `/api/v1`, which
 * assumes a same-origin deployment — no environment serves the API same-origin
 * today (server.mjs does not proxy `/api`), so always provide the variable.
 *
 * Values resolve runtime (`window.__APP_CONFIG__`) → build (`import.meta.env`)
 * → code default; see src/config/runtimeConfig.ts.
 */
import { readEnv } from './runtimeConfig'

/** Remove any trailing slash so callers can safely join with `/resource`. */
function normalizeBaseUrl(value: string): string {
  return value.replace(/\/+$/, '')
}

/** Base URL prepended to every backend resource path (never has a trailing slash). */
export const API_BASE_URL: string = normalizeBaseUrl(readEnv('VITE_API_BASE_URL') ?? '/api/v1')
